<template>
  <div id="favorite">
    <Header/>
    <div id="content">
      <Contents v-if="user_attribute" :target="this.user_attribute.target_subjects" page="favorite"/>
      <v-row>
        <v-col>
          <template v-if="user_attribute.target_subjects == null">
            <v-layout style="text-align: left;">
              <v-btn
                id="returnBtn"
                @click="returnAttribute">&lt; 属性選択へ戻る</v-btn>
            </v-layout>
            <div class="text-left"
              style="margin-bottom: 24px; font-size: 24px; border-bottom: solid #00a0e9; padding-left: 8px; border-left: 12px solid #faef05;"
            >2. マッチング結果</div>
          </template>
          <template v-else>
            <v-layout style="text-align: left;">
              <v-btn
                id="returnBtn"
                @click="returnSubject">&lt; 科目選択へ戻る</v-btn>
            </v-layout>
            <div class="text-left"
              style="margin-bottom: 24px; font-size: 24px; border-bottom: solid #00a0e9; padding-left: 8px; border-left: 12px solid #faef05;"
            >3. マッチング結果</div>
          </template>
          <div style="text-align: left;">
            <span style="white-space: pre-wrap;">{{ setting.keyword_description }}</span>
          </div>

          <div v-if="user_attribute.target_subjects != null" style="display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top: 48px;">
            <v-checkbox class="subject_sort" v-model="subject_sort" @click="others_index = null;" style="border-radius: 1vh;">
              <template v-slot:label>
                <span style="color: #000;">得意・苦手科目を考慮する</span>
              </template>
            </v-checkbox>
            <img src="images/ic_baseline-plus.png" style="width: 36px; height: 36px; margin-top: 24px;"/>
          </div>
          <v-card style="margin: 24px 0px 36px 0px; padding-bottom: 4px; border: #666 solid 1px; box-shadow: none;">
            <v-card-title
              style="width: 100%; background-color: #00A1E9; color: #FFF; display: flex; justify-content: space-between;">
              <div>キーワード選択</div>
              <div style="font-size: 16px;">
                <span style="font-size: 32px; margin-right: 8px;">{{ selected_keywords.length }}</span><span style="padding-bottom: -12px;">/ {{ selectKeywords.length }}</span>
                <v-btn @click="keywordsTrash" id="keywordTrash"><svg-icon style="color: #FFF; width: 16px; height: 16px;" type="mdi" :path="path"/><span>選択クリア</span></v-btn>
                <v-dialog v-if="dialog" v-model="dialog" width="90%" max-width="600px">
                  <v-card>
                    <v-card-title style="text-align: left;">
                      キーワードの選択状態をクリアしますか？
                    </v-card-title>
                    <v-card-text style="text-align: right;">
                      <v-btn @click="closeDialog"
                        style="background-color: #FFF; color: #000; font-size: 16px; font-weight: bold; min-width: 6em; height: 3em; margin-top: 12px; margin-bottom: 6px; margin-right: 12px;">キャンセル</v-btn>
                      <v-btn @click="selectedKeywordsClear"
                        style="background-color: #E76F00; color: #FFF; font-size: 16px; font-weight: bold; min-width: 6em; height: 3em; margin-top: 12px; margin-bottom: 6px;">OK</v-btn>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </div>
            </v-card-title>
            <div class="d-flex flex-md-row keyword-selector">
              <!-- カテゴリ表示部 -->
              <v-col class="keywordCategories">
                <v-card-text style="width: 100%;" class="pa-0" md="3">
                  <h4 class="text-left" style="font-size: 14px;">カテゴリ</h4>
                  <v-checkbox style="accent-color: #FFF; background-color: #FFF;" class="mb-2" dense hide-details
                    :input-value="isAllCategoriesSelected" @click="onSelectAllCategoryButtonClicked">
                    <template v-slot:label>
                      <div style="font-size: 14px;">全選択（{{ selectKeywords.length }}）</div>
                    </template>
                  </v-checkbox>
                  <v-divider />
                  <div :style="{
                    display: 'grid',
                    gridTemplateColumns:
                      'repeat(auto-fill, minmax(11em, 1fr))',
                  }">
                    <div v-for="keyword_category in keyword_categories" :key="keyword_category.id">
                      <v-checkbox style="accent-color: #FFF; background-color: #FFF;" :value="keyword_category.name"
                        v-model="selected_categories" @click="doKeyword" dense hide-details>
                        <template v-slot:label>
                          <div style="font-size: 14px;">{{ keyword_category.name }}（{{ keyword_category.keywords.length }}）</div>
                        </template>
                      </v-checkbox>
                    </div>
                  </div>
                </v-card-text>
              </v-col>
              <div class="divider"></div>
              <!-- キーワード表示部 -->
              <v-col class="keywords" :type="keywordsOfSelectedCategories.length == 0">
                <v-card-text style="width: 100%;" class="pa-0">
                  <div>
                    <template v-if="keywordsOfSelectedCategories.length > 0">
                      <div class="keywordDisplay">
                        <div v-for="keyword in keywordsOfSelectedCategories" :key="keyword"
                          class="d-flex flex-row justify-start align-center" :style="{ height: '3em' }">
                          <v-checkbox :label="keyword" v-model="selected_keywords" style="white-space: flex-nowrap; padding: 4px 16px 4px 8px;"
                            :value="keyword" @click="doKeyword" dense hide-details />
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div style="font-size: 16px; color: #817c7c;">カテゴリを選択してください</div>
                    </template>
                  </div>
                </v-card-text>
              </v-col>
            </div>
          </v-card>
          <!-- 研究室カード -->
          <div style="margin-bottom: 152px;">
            <div id="card_top" style="text-align: end;">全{{ laboratories.length }}件</div>
            <div style="margin-bottom: 16px; height: 64px; align-items: flex-end; position: sticky; top: -1px; z-index:1; display: flex; background-color: #FFF;">
                <div style="flex: 1;"><v-btn id="chartBtn" :value="chart == 'OFF'" @click="chartClick('OFF')">シンプルチャート</v-btn></div>
                <div style="width: 12px; border-bottom: solid 1px #999;"></div>
                <div style="flex: 1;"><v-btn id="chartBtn" :value="chart == 'ON'" @click="chartClick('ON')">詳細チャート</v-btn></div>
            </div>
            <template v-if="chart == 'OFF'">
              <template v-for="laboratory, index in sortedLaboratories">
                <laboratory-detail :laboratory="laboratory" :setting="setting" :index="index" :laboratories-count="laboratories.length" :attribute="user_attribute" :subject_sort="subject_sort"
                  :selected-keywords="selected_keywords" :chart="chart" :before-laboratories="sortedLaboratories" @labRank="laboratoryRank" @cardClick="chartChange" style="margin: 0;" :key="laboratory.id" />
                  <a v-smooth-scroll v-if="index == 1" class="pagetop" href="#favorite" :key="laboratory.id"><div class="pagetop__arrow" :key="laboratory.id"></div></a>
                  <div v-if="index == others_index" style="margin-top: 64px; margin-bottom: 16px;" :key="laboratory.id"><span style="font-size: 36px;">その他の研究室</span></div>
              </template>
            </template>
            <template v-else>
              <template v-for="laboratory, index in sortedLaboratories">
                <laboratory-detail :laboratory="laboratory" :setting="setting" :index="index" :laboratories-count="laboratories.length" :attribute="user_attribute" :subject_sort="subject_sort"
                  :selected-keywords="selected_keywords" :chart="chart" :before-laboratories="sortedLaboratories" @labRank="laboratoryRank" @cardClick="chartChange" style="margin: 24px 0;" :key="laboratory.id" />
                  <a v-smooth-scroll v-if="index == 1" class="pagetop" href="#favorite" :key="laboratory.id"><div class="pagetop__arrow" :key="laboratory.id"></div></a>
                  <div v-if="index == others_index" style="margin-top: 64px;" :key="laboratory.id"><span style="font-size: 36px;">その他の研究室</span></div>
              </template>
            </template>
          </div>
        </v-col>
      </v-row>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Footer from "../components/footer.vue";
import Header from "../components/header.vue";
import Contents from "../components/contents.vue";
import func from "../utils/function.js";
import LaboratoryDetail from "../components/LaboratoryDetail.vue";

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiTrashCanOutline } from '@mdi/js';

export default {
  name: "my-cool-component",
  components: {
    Header,
    Footer,
    Contents,
    LaboratoryDetail,
    SvgIcon,
  },
  data() {
    return {
      path: mdiTrashCanOutline,
      setting: [],//可変の設定
      keyword_categories: [],//大項目のキーワード
      keywords: [],//小項目のキーワード
      laboratories: [],//yamlから取得した研究室
      selected_categories: [],//選択したカテゴリ
      selected_keywords: [],//選択したキーワード
      selectKeywords: [],//選択できるキーワード
      user_attribute: {},//来訪user
      dialog: false,
      subject_sort: true,
      chart: "OFF",//表示するchartの切り替え※OFFがシンプルチャート
      others_index: null,//「他の研究室」を表示する場所
    }
  },
  created() {
    this.user_attribute = JSON.parse(localStorage.getItem('user_attribute'));
    if (!this.user_attribute) {//ユーザ属性のpropsがない場合の処理
      this.$router.push({ name: 'home' });
    }
    this.setting = this.$repository.setting;
    this.laboratories = this.$repository.getLaboratories(this.user_attribute).map((laboratory) => {
      const lab = structuredClone(laboratory)
      //cos類似度の初期値設定
      lab.similarity_keywords = 0
      lab.similarity_subjects = 0
      return lab
    });
    this.keyword_categories = this.$repository.getKeywordCategories(this.user_attribute);
    this.keywords = this.$repository.keyword.keywords;

    this.keyword_categories.forEach(keywordCategory => {
      keywordCategory.keywords.forEach(keyword => {//選択できるキーワードの作成
        if(!this.selectKeywords.some(key => key == keyword)){
          this.selectKeywords.push(keyword)
        }
      })
    })

    const keywordsAnswerStatus = JSON.parse(localStorage.getItem('keywords_answer_status'))
    const savedKeywordCategories = keywordsAnswerStatus ? keywordsAnswerStatus[this.user_attribute.name] : null

    this.doSubject();
    // 保持されたキーワード選択状態を復元
    if (savedKeywordCategories) {
      const selectedKeywordsWithDuplication = []
      Object.entries(savedKeywordCategories).forEach(([category, keywords]) => {
        this.selected_categories.push(category);
        Object.entries(keywords).forEach(([keyword, value]) => {
          if (value) {
            selectedKeywordsWithDuplication.push(keyword)
          }
        })
      })
      this.selected_keywords = Array.from(new Set(selectedKeywordsWithDuplication))
      this.doKeyword();
    }
    else {//保持されていない際にキーワードのcos類似度を0にする処理
      this.laboratories.forEach(laboratory => {
        laboratory.similarity_keywords = 0;
      })
    }
    if(this.selected_categories.length == 0){
      this.selected_categories = this.keyword_categories.map(category => category.name)
      this.doKeyword()
    }
  },
  methods: {
    chartClick(mode) {
      if(this.chart != mode) {
        this.chart = mode;
        setTimeout(function() {
          // 待機後の処理
          let targetElement = document.getElementById("card_top");
          if (targetElement) {
            let topPosition = targetElement.offsetTop;
            window.scrollTo({
              top: topPosition,
            });
          }
        }, 1);
      }
    },
    chartChange(lab) {
      const top_constant = 64;//戻った先の高さ調整
      if(this.chart == 'OFF') {
        this.chart = 'ON';
      }
      else {
        this.chart = 'OFF';
      }
      setTimeout(function() {
        // 待機後の処理
        if(this.chart == 'OFF'){
          console.log(document.getElementById(lab))
        }
        let targetElement = document.getElementById(lab);
        if (targetElement) {
          let topPosition = targetElement.offsetTop - top_constant;
          window.scrollTo({
            top: topPosition,
          });
        }
      }, 1);
    },
    laboratoryRank(laboratory_rank, laboratory_index) {
      if(laboratory_rank > (this.setting.others_laboratories - 1) && this.others_index == null) {
        this.others_index = laboratory_index - 1;
      }
    },
    closeDialog() {
      this.dialog = false;
    },
    keywordsTrash() {
      this.dialog = true;
    },
    doSubject() {//得意科目のcos類似度を算出
      const subjects_answer_status = JSON.parse(localStorage.getItem('subjects_answer_status'));//属性ごとの選択状況
      const user_subjects = subjects_answer_status ? subjects_answer_status[this.user_attribute.name] : null
      if (!user_subjects) {
        this.laboratories.forEach(laboratory => {
          laboratory.similarity_subjects = 0;
        })
        return;
      }

      //全ての科目
      const answerdSubjects = Object.fromEntries(Object.entries(user_subjects))

      const answerdSubjectNames = Object.keys(answerdSubjects)
      const userSubjectVector = Object.values(answerdSubjects)
      this.laboratories.forEach((laboratory) => {//研究室ループ
        if(userSubjectVector.some(sub => sub != 0)){//1つでも科目の選択がされているか判別
          const laboratorySubjectVector = answerdSubjectNames.map(subjectName => laboratory.subject_weights[subjectName] ? laboratory.subject_weights[subjectName] : 0)
          const userSubjectVectorMasked = userSubjectVector.map((subject, index) => {
            return Math.min(subject, laboratorySubjectVector[index])//ユーザーの選択が研究室の値を超えていた際に丸める処理
          })
          const similarity = func.similarity(laboratorySubjectVector.map(sub => sub / 5), userSubjectVectorMasked.map(sub => sub / 5), null);

          laboratory.similarity_subjects = similarity ? similarity : 0
        }
        else{
          laboratory.similarity_subjects = null;
        }
      })
    },
    selectedKeywordsClear() {
      //選択をOFFにする処理
      this.keyword_categories.forEach(keywordCategory => {//全カテゴリループ
        keywordCategory.keywords.forEach(keyword => {
          this.selected_keywords = this.selected_keywords.filter(k => k != keyword);
        });
      })
      this.doKeyword();
      this.dialog = false;
    },
    doKeyword() {//キーワードのcos類似度を算出
      let user_categories = {}//選択されているカテゴリ
      let keyword_count = 0;
      this.others_index = null;//その他の研究室の位置を初期化する処理

      this.keyword_categories.forEach(keywordCategory => {//全カテゴリループ
        if (this.selected_categories.some(selected_category => {//カテゴリが選択されているか判別
          return selected_category == keywordCategory.name;//選択されていた際の処理
        })) {
          let user_keyword = {};
          keywordCategory.keywords.forEach(keyword => {//選択されたキーワード
            //キーワード選択の保持
            user_keyword[keyword] = this.selected_keywords.includes(keyword)
          })
          user_categories[keywordCategory.name] = user_keyword;//カテゴリの保持、カテゴリにキーワードの選択状態を保持
        }
        else {
          //所持しているcos類似度の初期化
          this.laboratories.forEach(laboratory => {
            laboratory.similarity_keywords = 0;
          })
        }
      })

      let user_attributes = {};
      if (localStorage.getItem('keywords_answer_status')) {
        user_attributes = JSON.parse(localStorage.getItem('keywords_answer_status'));
      }
      user_attributes[this.user_attribute.name] = user_categories;
      localStorage.setItem('keywords_answer_status', JSON.stringify(user_attributes));
      if (this.keywords.length == keyword_count) {//キーワードが何も入力されていない場合に終了するための処理
        return;
      }

      //選択されたキーワード
      const selectedKeywords = this.keywords.filter(keyword => {
        return this.selected_keywords.includes(keyword)
      })
      let calculationTargetKeywords;
      if (this.setting.keyword_score_mode != 'COS_VECTOR_LENGTH_FIX') {
        //選択したキーワードのみを対象(可変)
        calculationTargetKeywords = selectedKeywords
      }
      else {
        // 類似度計算対象とするキーワード(全キーワード対象、固定)
        calculationTargetKeywords = this.selectKeywords
      }

      // ユーザの類似度比較用ベクトル
      const userKeywordVector = calculationTargetKeywords.map(keyword => {
        let weight_max = 1;

        //userの持つ値
        return this.selected_keywords.includes(keyword) ? weight_max : -1
      })

      this.laboratories.forEach(laboratory => {
        // 研究室の類似度比較用ベクトル
        const laboratoryKeywordVectorScaling = calculationTargetKeywords.map(keyword => {
          let weight_max = 0;
          if (this.setting.keyword_weight_regulation_value == 'MAX_WEIGHT_ALL'){ //全キーワードの最大値を比率に設定
            this.laboratories.forEach(laboratory => {
              Object.values(laboratory.keyword_weights).forEach(weight => {
                weight_max = Math.max(weight_max, weight);
              })
            })
          }
          else if(this.setting.keyword_weight_regulation_value == 'MAX_WEIGHT_ONE_KEYWORD') { //キーワードごとの最大値を比率に設定
            this.laboratories.forEach(laboratory => {
              if(laboratory.keyword_weights[keyword]){
                weight_max = Math.max(weight_max, laboratory.keyword_weights[keyword]);
              }
            })
          }
          else { //固定値
            weight_max = 100;
          }
          return laboratory.keyword_weights[keyword] ? laboratory.keyword_weights[keyword] / weight_max : 0
        })

        if (selectedKeywords.length > 0) {
          let similarity = func.similarity(laboratoryKeywordVectorScaling, userKeywordVector, this.setting);
          //ベクトル長が固定の場合、-1～1なので0～1にするための処理
          if (this.setting.keyword_score_mode == 'COS_VECTOR_LENGTH_FIX') {
            similarity = similarity / 2 + 0.5;
          }
          laboratory.similarity_keywords = similarity ? similarity : 0;
        }
        else {//キーワードが選択されていないとき
          this.laboratories.forEach(laboratory => {
            laboratory.similarity_keywords = 0;
          })
        }
      })

    },
    returnSubject() {
      this.$router.push({ name: 'subject' });
    },
    returnAttribute() {
      this.$router.push({ name: 'home' });
    },
    onSelectAllCategoryButtonClicked() {
      if (this.isAllCategoriesSelected) {
        this.selected_categories = []
      } else {
        this.selected_categories = this.keyword_categories.map(category => category.name)
      }

      this.doKeyword()
    }
  },
  computed: {
    keywordsOfSelectedCategories() {
      const keywordsWithDuplication = this.keyword_categories.filter((category) => {
        return this.selected_categories.includes(category.name)
      }).flatMap(category => category.keywords)

      // 重複を排除
      return Array.from(new Set(keywordsWithDuplication))
    },
    isAllCategoriesSelected() {
      return this.selected_categories.length == this.keyword_categories.length
    },
    sortedLaboratories() {
      if(this.subject_sort){
        return this.laboratories.toSorted(function (a, b) {
          return ((a.similarity_subjects + a.similarity_keywords) / 2 > (b.similarity_subjects + b.similarity_keywords) / 2) ? -1 : 1;
        });
      }
      else{
        return this.laboratories.toSorted(function (a, b) {
          return (a.similarity_keywords > b.similarity_keywords) ? -1 : 1;
        });
      }
    },
  },

}
</script>

<style scoped>
/*スマホ画面*/
#content {
  width: auto;
  max-width: 900px;
  margin: 0 5%;
  padding: 0;
}
#returnBtn {
  background-color: #FFF;
  border: solid 1px black;
  width: 100%;
  height: 3em;
  box-shadow: none;
  margin-top: 12px;
  margin-bottom: 64px;
}
#chartBtn {
  width: 100%;
  box-shadow: none;
  background-color: #DDD;
  border: solid 1px #999;
  border-radius: 4px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
#chartBtn[value="true"] {
  background-color: #FFF;
  border-bottom: none;
  cursor: default; /* アクティブな場合は指を示すカーソルを適用しない */
  pointer-events: none; /* カーソルイベントを無効化 */
}
.subject_sort {
  width: 100%;
  height: 4em;
  border: #000 solid 1px;
  padding: 4vw 16vw;
}
.keywordDisplay {
  display: grid;
  grid-template-columns:  auto auto;
}
.v-application .primary--text {
  /* Opacity: 50%; */
  background-color: #cdefff;
  border-radius: 100vh;
}
.pagetop {
    height: 50px;
    width: 50px;
    margin-top: 6px;
    margin-bottom: -56px;
    position: sticky;
    top: 90vh;
    left: 95vw;
    background: #faef05;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
}

.pagetop__arrow {
  display: inline-block;
  vertical-align: middle;
  color: #00A1E9;
  line-height: 1;
  position: relative;
  width: 0.1em;
  height: 1em;
  background: currentColor;
}
.pagetop__arrow::before {
  content: '';
  width: 0.65em;
  height: 0.65em;
  border: 0.1em solid currentColor;
  border-left: 0;
  border-bottom: 0;
  transform: rotate(-45deg);
  transform-origin: top right;
  position: absolute;
  top: -0.05em;
  right: 50%;
  box-sizing: border-box;
}
#keywordTrash {
  padding: 4px;
  height: 20px;
  width: 32px;
  margin-top: -10px;
  margin-left: 12px;
  border-left: 24px;
  box-shadow: none;
  font-size: 16px;
  background: transparent;
  border-radius: 3px;
  color: #FFF;
  font-size: 8px;
  border: #FFF solid 1px;
}
.keywordCategories {
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
}
.keywords {
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  padding-left: 24px;
}
.keywords[type = 'true']{
  display: flex;
  align-items: center;
} 
.keyword-selector {
  flex-direction: column;
}
/*タブレット画面*/
@media (min-width: 450px) {
  #returnBtn {
    width: 12em;
    margin-bottom: 48px;
  }
  .subject_sort {
    width: 21em;
    padding: 20px 48px 0 48px;
  }
}
/*PC画面*/
@media (min-width: 960px) {
  #content {
    margin: 0 auto;
    width: 900px;
  }
  #subjectName {
    width: 34%;
  }
  .keywordDisplay {
    grid-template-columns: auto auto auto;
  }
  .keywordCategories {
    max-width: 20%;
  }
  .keywords {
    max-width: 80%;
  }
  .keyword-selector {
    flex-direction: row;
  }
}
.divider {
  flex: 0 0 .5px;
  background-color: #817c7c;
}
.keyword-selector {
  height: 75vh;
}
@media (min-width: 450px) {
  .keyword-selector {
    height: 50vh;
  }
}
</style>